__webpack_require__.p = "https://sop034.berlin/konfigurator/";